var __s__ = require('./support-fns.js');
// var THREE = require('three');

//Class Tooth
export class Tooth {

    constructor (name, uns, fdi, upper, parentJaw, material) {
        this.name = name

        this.__isHighlighted = false;

        this.object3D = new THREE.Object3D();
        this.object3D.name = this.name;

        let extrasHolder = new THREE.Group();
        extrasHolder.name = "extrasHolder";
        this.object3D.add(extrasHolder);
        this.object3D.extrasHolder = extrasHolder;

        let toothHolder = new THREE.Group();
        toothHolder.name = "toothHolder";
        this.object3D.add(toothHolder);
        this.object3D.toothHolder = toothHolder;

        this.numberUNS = uns;
        this.numberFDI = fdi;
        this.nameComposed = "u-" + uns + "_f-" + fdi;

        this.upper = upper;
        this.parentJaw = parentJaw;
        this._opacity = 1;

        this.previous = null;
        this.next = null;
        this._connectors = new Map();

        this._extraModels = new Map();

        //THREE Materials
        this.__material = material.clone();
        this.__defaultMaterial = material.clone();

        //Info (Type, Material, Meta)
        this._info = { type: "", material: "", meta: {}};

        this.obj3DInfo = null;
    }

    get visible() { return this._visible; }
    set visible(v) { this._visible = !!v;
        this.object3D.visible = this._visible;
    }

    get opacity() { return this._opacity; }
    set opacity(v) {
        let me = this;
        if (isNaN(v)) { console.warn("Opacity not a number!. Nothing set."); return; }
        v = Math.max(0, Math.min(1, v));
        this._opacity = v;
        this.object3D.toothHolder.traverse(function(child) {
            child.material.opacity = v;
        });
    }

    //Specifies the tooth type. This will simply be a string representing the planned treatment/replacement, for instance a crown.
    get type() { return this._info.type; }
    set type(v) { this._info.type = v; this.updateConnectors(); }

    //Specifies the material for the replacement, e.g. “gold” for a crown.
    get material() { return this._info.material; }
    set material(v) { this._info.material = v; this.updateConnectors(); }

    get meta() { return this._info.meta; }
    get info() {
        return {
            UNS: this.numberUNS,
            FDI: this.numberFDI,
            info: this._info,
            connectors: this.connectors
        };
    }

    get extraModels() { return this.getExtraModelsList(); }

    _addPartMesh(mesh, isCrown) {
        if (!!isCrown) { this.object3D.theCrown = mesh; }
        this.object3D.toothHolder.add(mesh);
        mesh.parentTooth = this.nameComposed;
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    setOpacity(v, animate = 0) {
        let me = this;

        if (animate === 0) {
            this.opacity = v;
            return;
        }

        //if animate > 0
        TweenLite.to(this,
            animate,
            {
                opacity: v,
                ease: Power2.easeOut
            }
        );
    }

    //newColor can be a string (#333000) or a THREE.Material
    setTexture(newColor, persist = true) {
        let material,
            colorNum;

        if (typeof newColor === "string") {
            colorNum = parseInt("0x" + newColor.replace("#", ""), 16);
            material = new THREE.MeshPhongMaterial({ color: colorNum, transparent: true, shininess: 100});
        } else {
            material = newColor;
        }

        try {
            this.object3D.toothHolder.traverse(function(child) {
                child.material = material;
            });
        }
        catch(err) {
            console.warn(err);
            return;
        }
        if (persist) { this.__material = material.clone(); }
    }

    reset() {
        this.removeExtraModelsAll();
        this.visible = true;
        this.__isHighlighted = false;
        // this.opacity = 1;
        this.setTexture(this.__defaultMaterial.clone());
    }

    resetColor() {
        this.setTexture(this.__defaultMaterial.clone());
    }

    //Shortcuts of treatment info
    setType(type) {
        this.type = type;
        //Dispatch event
        ev = __s__.addEventDsptchr("toothSetType");
        ev.target = this;
        sc.getElement().dispatchEvent(ev);
    }
    setMaterial(material) {
        this.material = material;
        //Dispatch event
        ev = __s__.addEventDsptchr("toothSetMaterial");
        ev.target = this;
        sc.getElement().dispatchEvent(ev);
    }
    setMeta(ob) {
        this.meta = ob;
        //Dispatch event
        ev = __s__.addEventDsptchr("toothSetMeta");
        ev.target = this;
        sc.getElement().dispatchEvent(ev);
    }

    //Conectors ------
    updateConnectors() {
        for (let value of this._connectors.values()) {
            if (this.material !== value.material ||
                this.type !== value.type) {
                    this.disconnect(value);
                }
        }
    }

    connect(target) {
        if (target === null || target === undefined || (target !== this.previous && target !== this.next)) {
            console.warn("target tooth is not connectable. Noting set.");
            return false;
        }

        let sc = this.parentJaw.scene, ev;

        if (!this._connectors.has(target.nameComposed)) {
            if (this.material === target.material &&
                this.type === target.type) {
                    //Connect this to target
                    this._connectors.set(target.nameComposed, target);
                    //Connect target to this
                    target._connectors.set(this.nameComposed, this);
                    //Change color
                    let cn = sc.getConnector(this, target);
                    cn.toggleConnectorColor(true);
                    //Dispatch event
                    ev = __s__.addEventDsptchr("connect");
                    sc.getElement().dispatchEvent(ev);

                    return true;
                } else {
                    console.warn("target is of different type/material. Not connected.");
                    return false;
                }
        } else {
            console.warn("target is already connected.");
            return false;
        }
    }

    disconnect(target) {
        let sc = this.parentJaw.scene, ev;
        if (this._connectors.has(target.nameComposed)) {
            //Disconnect this to target
            this._connectors.delete(target.nameComposed);
            //Disconnect target to this
            target._connectors.delete(this.nameComposed);
            //Change color
            let cn = sc.getConnector(this, target);
            cn.toggleConnectorColor(false);
            //Dispatch event
            ev = __s__.addEventDsptchr("disconnect");
            sc.getElement().dispatchEvent(ev);
            return true;
        } else {
            console.warn("target is not a connection. Nothing deleted.");
            return false;
        }
    }

    isConnectedTo(target) {
        return this._connectors.has(target.nameComposed);
    }

    getConnections() {
        let arr = [];
        for (let value of this._connectors.values()) {
            arr.push(value);
        }
        return arr;
    }

    getPrevious() {
        return this.previous;
    }
    getNext() {
        return this.next;
    }

    //Add Extra Model to tooth ------

    //Add model. Parameter is the name.
    addExtraModel(name, removeAllPreviousExtraModels = false) {
        let me = this,
            renderer3d = this.parentJaw.scene.renderer3d,
            modelInfo;

        if (this._extraModels.has(name)) {
            console.warn("Extra-model already attached. Nothing changed.");
            return false;
        }

        //Remove previous extras
        if (removeAllPreviousExtraModels) {
            this.removeExtraModelsAll();
        }

        //Get ExtraModel info object
        modelInfo = renderer3d._extrasInfo.get(name);

        renderer3d.loadExtraModel(modelInfo)
            .then(function() {
                let exm = renderer3d.insertExtraModel(me, name);
                if (exm !== null) {
                    //Add name & object3d ref to the Map
                    me._extraModels.add(name, exm);
                }
            });
    }

    removeExtraModel(name) {
        //Please provide a name
        if (!name) {
            console.warn("Extra-model name not provided. Nothing removed.");
            return false;
        }

        let children = this.object3D.extrasHolder.children,
            child;

        if (!this._extraModels.has(name)) {
            console.warn("Extra-model not found. Nothing removed.");
            return false;
        }

        this._extraModels.delete(name);
        //Iterate to find a child with that Extra Model name
        for (let i = children.length - 1; i >= 0; i--) {
            child = children[i];
            if (child.name === name) {
                this.object3D.extrasHolder.remove(child);
                return true;
            }
        }
    }

    removeExtraModelsAll() {
        let children = this.object3D.extrasHolder.children,
            child;

        for (let i = children.length - 1; i >= 0; i--) {
            child = children[i];
            this.object3D.extrasHolder.remove(child);
        }

        this._extraModels.clear();
    }

    getExtraModelsList() {
        let arr = [];
        for (let exm of this._extraModels) {
            arr.push(exm);
        }
        return arr;
    }

    setExtraModelsVisibility(v) {
        this.extrasHolder.visible = !!v;
    }

    setExtraModelsOpacity(v) {
        if (isNaN(v)) { console.warn("Opacity not a number!. Nothing set."); return; }
        v = Math.max(0, Math.min(1, v));

        this.object3D.extrasHolder.traverse(function(child) {
            if (child.material) { child.material.opacity = v; }
        });
    }

}
